<template>
  <div class="details-subsection">
    <div class="details-content">
      <h2 class="details-title">Besoin de plus de détails ?</h2>
      <p class="details-description">
        Explorez toutes les fonctionnalités de Florisuite en profondeur pour comprendre comment chaque outil peut propulser votre entreprise.
      </p>
      <router-link class="details-button" to="/fonctionnalites">
        <span class="details-button-text">Voir toutes les fonctionnalités</span>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DetailsSubsection",
});
</script>

<style>
.details-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px 30px 100px;
  position: relative;
  width: 100%;
}

.details-subsection .details-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 25px;
  max-width: 826px;
  min-width: 350px;
  width: 100%;
}

.details-subsection .details-title {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
  margin: 0;
  text-align: center;
  width: 100%;
}

.details-subsection .details-description {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
  margin: 0;
  max-width: 835px;
  text-align: center;
  width: 100%;
}

.details-subsection .details-button {
  all: unset;
  align-items: center;
  background-color: #084734;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: 44px;
  overflow: hidden;
  padding: 12px 20px;
  position: relative;
  width: min(100%, 568px);
}

.details-subsection .details-button-text {
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  position: static;
  text-align: center;
  white-space: normal;
}

@media (max-width: 768px) {
  .details-subsection .details-content {
    min-width: 0;
  }

  .details-subsection .details-title {
    font-size: 30px;
    line-height: 1.2;
  }

  .details-subsection .details-description {
    font-size: 16px;
    line-height: 1.45;
  }

  .details-subsection .details-button-text {
    font-size: 16px;
    line-height: 1.3;
  }
}
</style>
